import Webcam from "react-webcam";
import * as faceapi from "face-api.js";

import { useRef, useState, useCallback } from "react"; // import useRef
import PropTypes from "prop-types";
import {
  Box,
  // Grid,
  Icon,
  // FormControl,
  // InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Snackbar,
  Alert,
  IconButton,
  Button,
  Typography,
} from "@mui/material";

function HumanFaceField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const webcamRef = useRef(`${fieldRef}_${displayName}`); // create a webcam reference
  const [imgSrc, setImgSrc] = useState(null);
  const [capturedImg, setCapturedImg] = useState(null);
  const [cameraUsed, setCameraUsed] = useState(false);
  const [uploadType, setUploadType] = useState(null);

  const placeholderImg =
    "data:image/jpeg;base64,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";

  const videoConstraints = {
    facingMode: cameraUsed ? "user" : { exact: "environment" },
  };

  const [openWebCamDialog, setOpenWebCamDialog] = useState(false);
  const [faceDetectionError, showFaceDetectionError] = useState(false);

  async function validateFace(bas64ImageData) {
    await faceapi.loadTinyFaceDetectorModel("/face_models");
    const base64Response = await fetch(bas64ImageData);
    const blob = await base64Response.blob();
    const image = await faceapi.bufferToImage(blob);

    const detection = await faceapi.detectSingleFace(
      image,
      new faceapi.TinyFaceDetectorOptions()
    );
    if (!detection) {
      showFaceDetectionError(true);
      return false;
    }

    return true;
  }

  // create a capture function
  const capture = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      setErrorMsg("No photo image found.");
      showFieldError(true);
      return;
    }

    const passed = await validateFace(imageSrc);
    if (passed) {
      setImgSrc(imageSrc);
      setCapturedImg(imageSrc);
      setOpenWebCamDialog(false);
    }
  }, [webcamRef]);

  async function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

  async function handleSelectedFileChange(event) {
    const file = event.target.files[0];
    const fileKb = Math.round(file.size / 1024);
    if (fileKb > 5000) {
      setErrorMsg("File size cannot exceed 5MB.");
      showFieldError(true);
      return;
    }

    await toBase64(file)
      .then(async (res) => {
        if (
          res.startsWith("data:image/heic;base64") ||
          res.includes("data:image/heic;base64")
        ) {
          setErrorMsg(
            "File format not supported. Recommended image formats: JPEG, JPG, PNG"
          );
          showFieldError(true);
          return;
        }

        const passed = await validateFace(res);
        if (passed) {
          setImgSrc(res);
          setCapturedImg(res);
          setOpenWebCamDialog(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setErrorMsg(err);
        showFieldError(true);
      });
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openWebCamDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <Box>
            {uploadType === "scan" ? "Take a picture" : "Upload picture"}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={2} mb={3}>
            {uploadType === "scan" ? (
              <Box>
                <Webcam
                  // height={"100%"}
                  width="100%"
                  ref={webcamRef}
                  screenshotQuality={1}
                  videoConstraints={videoConstraints}
                  mirrored={cameraUsed ? true : false}
                />
                <Box align="right">
                  <IconButton
                    onClick={() => {
                      setCameraUsed(!cameraUsed);
                    }}
                    color="warning"
                    variant="outlined"
                  >
                    <Icon>cameraswitch</Icon>
                  </IconButton>
                  &nbsp;
                  <IconButton
                    color="info"
                    variant="outlined"
                    iconOnly
                    circular
                    onClick={capture}
                  >
                    <Icon>photo_camera</Icon>
                  </IconButton>
                </Box>
              </Box>
            ) : (
              <Box>
                <TextField
                  fullWidth
                  inputProps={{
                    multiple: false,
                    accept: "image/*",
                  }}
                  placeholder={displayName}
                  type="file"
                  options={options}
                  onChange={(e) => handleSelectedFileChange(e)}
                />
              </Box>
            )}
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              autoHideDuration={5000}
              onClose={() => showFaceDetectionError(false)}
              open={faceDetectionError}
            >
              <Alert severity="error" sx={{ width: "100%" }}>
                Unable to detect a clear face in picture.
              </Alert>
            </Snackbar>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenWebCamDialog(false);
            }}
            color="primary"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ minWidth: 120, width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={6}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} lg={6}>
            <Box align="right">
              <IconButton
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  setUploadType("scan");
                  setImgSrc(null);
                  setCapturedImg(null);
                  setOpenWebCamDialog(true);
                }}
                options={options}
              >
                <Icon>camera_alt</Icon>
              </IconButton>
              &nbsp;
              <IconButton
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  setUploadType("file");
                  setImgSrc(null);
                  setCapturedImg(null);
                  setOpenWebCamDialog(true);
                }}
                options={options}
              >
                <Icon>upload_file</Icon>
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Box>
          <Box>
            <Box>
              {imgSrc ? (
                <img src={imgSrc} alt="webcam" width="20%" />
              ) : (
                <img src={placeholderImg} alt="webcam" width={100} />
              )}
            </Box>
            <input
              id={`dff_${fieldRef}`}
              type="hidden"
              name={fieldRef}
              value={capturedImg}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

// Typechecking props of the Transaction
HumanFaceField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

HumanFaceField.defaultProps = {
  options: null,
};

export default HumanFaceField;
